
import { Avatar,
  Button,
  CssBaseline,
  IconButton,
  FormControl,
  Paper, InputAdornment, TextField } from '@material-ui/core';
import LockIcon from '@material-ui/icons/LockOutlined';
import Visibility from '@material-ui/icons/VisibilityOutlined';
import VisibilityOff from '@material-ui/icons/VisibilityOffOutlined';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import LinearProgressBlockScreen from './share/LinearProgressBlockScreen';
import { action, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';

import VariantSnackbar from './share/VariantSnackbar';

const styles = theme => ({
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
});

@inject('usuarioStore')
@inject('routerStore')

@observer
class Login extends React.Component {
  state = {
    showPassword: false,
    loading: false,
    erroLogin: false,
    msgErroLogin: 'Usuário não encontrado ou senha incorreta!',
    openSnack: false
  }
  @observable codUsuario = '';
  @observable senha = '';
  @observable submit = false;

  componentDidMount = () => {
    this.props.usuarioStore.isUsuarioLogado
      ? this.props.routerStore.push('/dashboard')
      : this.props.routerStore.push('/');
  };
  handleCloseSnackbar = () => {
    this.setState({openSnack: false});
  };

  @action handleChangeCodUsuario = (event) => {
    this.setState({erroLogin: false});
    this.codUsuario = event.target.value;
  }

  @action handleChangeSenha = (event) => {
    this.setState({erroLogin: false});
    this.senha = event.target.value;
  }

  @action.bound realizarLogin = async (event) => {
    event.preventDefault();
    this.setState({loading: true});
    try {
      this.submit = true;
      await this.props.usuarioStore.realizarLogin(this.codUsuario.toUpperCase(), this.senha);
      const path = this.props.usuarioStore.previousPath !== undefined ? this.props.usuarioStore.previousPath : '/dashboard';
      this.props.routerStore.push(path);
    } finally {
      this.setState({loading: false, erroLogin: true, openSnack: true});
      runInAction(() => {
        this.submit = false;
      });
    }
    this.setState({loading: false});
  }

  handleClickShowPassword = () => {
    this.setState({showPassword: !this.state.showPassword});
  }

  handleMouseDownPassword = () => {
    this.setState({showPassword: !this.state.showPassword});
  }
  render () {
    const { classes } = this.props;
    const { loading } = this.state;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          {loading ? <LinearProgressBlockScreen />
            : <Paper className={classes.paper}>
              <Avatar className={classes.avatar}>
                <LockIcon />
              </Avatar>
              <Typography variant='headline'>TST-Saúde</Typography>
              <form className={classes.form}>
                <FormControl margin='normal' required fullWidth>
                  <TextField
                    id='codUsuario'
                    name='codUsuario'
                    autoComplete='username'
                    error={this.codUsuario === ''}
                    label={this.codUsuario === '' ? 'Informe o código de usuário' : 'Usuário*'}
                    value={this.codUsuario}
                    onChange={this.handleChangeCodUsuario}
                    autoFocus />
                </FormControl>
                <FormControl margin='normal' required fullWidth>
                  <TextField
                    id='senha'
                    name='senha'
                    type={this.state.showPassword ? 'text' : 'password'}
                    error={this.senha === ''}
                    label={this.senha === '' ? 'Informe a senha' : 'Senha*'}
                    value={this.senha}
                    onChange={this.handleChangeSenha}
                    autoComplete='current-password'
                    InputProps={{
                      endAdornment: (
                        this.senha !== '' &&
                        <InputAdornment position='end'>
                          <IconButton
                            disableRipple
                            onClick={this.handleClickShowPassword}
                            onMouseDown={this.handleMouseDownPassword}
                          >
                            {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </FormControl>
                <Button
                  type='submit'
                  fullWidth
                  variant='raised'
                  color='primary'
                  className={classes.submit}
                  onTouchStart={this.realizarLogin}
                  onClick={this.realizarLogin}
                  title='Acessar o sistema'
                  disabled={!this.codUsuario || !this.senha}
                >
                  Login
                </Button>
                <VariantSnackbar
                  vertical={'top'}
                  horizontal={'right'}
                  variant={'error'}
                  message={this.state.msgErroLogin}
                  open={this.state.openSnack}
                  handleClose={this.handleCloseSnackbar} />
              </form>
            </Paper>}
        </main>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);
